import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, CheckCircle, XCircle, Eye, Clock, Filter, Search } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/Tabs';
export function AdminApprovals() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const approvals = [{
    id: 1,
    name: 'PT Tech Indonesia',
    email: 'contact@techindonesia.com',
    type: 'Organisasi',
    membershipType: 'Organisasi Pendidikan',
    submittedDate: '15 Jan 2025',
    status: 'pending',
    documents: ['KTP', 'NPWP', 'Akta Perusahaan']
  }, {
    id: 2,
    name: 'Jane Smith',
    email: 'jane.smith@email.com',
    type: 'Individu',
    membershipType: 'Individu Umum',
    submittedDate: '14 Jan 2025',
    status: 'pending',
    documents: ['KTP', 'Ijazah']
  }, {
    id: 3,
    name: 'Bandung Dev Community',
    email: 'admin@bandungdev.com',
    type: 'Chapter',
    membershipType: 'Chapter Regional',
    submittedDate: '12 Jan 2025',
    status: 'pending',
    documents: ['Proposal', 'Struktur Organisasi']
  }, {
    id: 4,
    name: 'CV Digital Solutions',
    email: 'info@digitalsolutions.id',
    type: 'Badan Usaha',
    membershipType: 'Usaha Kecil',
    submittedDate: '10 Jan 2025',
    status: 'approved',
    documents: ['SIUP', 'TDP', 'NPWP'],
    approvedDate: '11 Jan 2025'
  }, {
    id: 5,
    name: 'Ahmad Fauzi',
    email: 'ahmad.fauzi@email.com',
    type: 'Individu',
    membershipType: 'Individu Pelajar',
    submittedDate: '8 Jan 2025',
    status: 'rejected',
    documents: ['KTP', 'Kartu Pelajar'],
    rejectedDate: '9 Jan 2025',
    rejectionReason: 'Dokumen tidak lengkap'
  }];
  const filteredApprovals = approvals.filter(approval => {
    const matchesTab = activeTab === 'all' || approval.status === activeTab;
    const matchesSearch = approval.name.toLowerCase().includes(searchQuery.toLowerCase()) || approval.email.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesTab && matchesSearch;
  });
  const stats = [{
    label: 'Menunggu Review',
    value: approvals.filter(a => a.status === 'pending').length.toString(),
    icon: Clock,
    color: 'text-warning',
    bgColor: 'bg-warning-light'
  }, {
    label: 'Disetujui',
    value: approvals.filter(a => a.status === 'approved').length.toString(),
    icon: CheckCircle,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }, {
    label: 'Ditolak',
    value: approvals.filter(a => a.status === 'rejected').length.toString(),
    icon: XCircle,
    color: 'text-error',
    bgColor: 'bg-error-light'
  }];
  const handleApprove = (id: number) => {
    if (confirm('Apakah Anda yakin ingin menyetujui permohonan ini?')) {
      alert(`Permohonan #${id} telah disetujui`);
    }
  };
  const handleReject = (id: number) => {
    const reason = prompt('Alasan penolakan:');
    if (reason) {
      alert(`Permohonan #${id} ditolak. Alasan: ${reason}`);
    }
  };
  return <div className="min-h-screen bg-white" data-id="element-557">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-558">
        {/* Header */}
        <div className="mb-8" data-id="element-559">
          <Button variant="ghost" onClick={() => navigate('/admin/dashboard')} className="mb-4" data-id="element-560">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-561" />
            Kembali ke Dasbor
          </Button>
          <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-562">
            Persetujuan Keanggotaan
          </h1>
          <p className="text-neutral-600" data-id="element-563">
            Review dan setujui permohonan keanggotaan baru
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-564">
          {stats.map((stat, i) => <Card key={i} data-id="element-565">
              <CardContent className="p-6" data-id="element-566">
                <div className="flex items-center gap-4" data-id="element-567">
                  <div className={`p-3 rounded-lg ${stat.bgColor}`} data-id="element-568">
                    <stat.icon className={`w-6 h-6 ${stat.color}`} data-id="element-569" />
                  </div>
                  <div data-id="element-570">
                    <p className="text-2xl font-semibold text-neutral-900" data-id="element-571">
                      {stat.value}
                    </p>
                    <p className="text-sm text-neutral-600" data-id="element-572">{stat.label}</p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>

        {/* Search & Filter */}
        <div className="flex flex-col sm:flex-row gap-4 mb-6" data-id="element-573">
          <div className="flex-1 relative" data-id="element-574">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-400" data-id="element-575" />
            <Input placeholder="Cari nama atau email..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10" data-id="element-576" />
          </div>
          <Button variant="secondary" data-id="element-577">
            <Filter className="w-4 h-4 mr-2" data-id="element-578" />
            Filter
          </Button>
        </div>

        {/* Tabs */}
        <Tabs defaultValue="all" className="w-full" data-id="element-579">
          <TabsList className="bg-neutral-100 border border-neutral-200" data-id="element-580">
            <TabsTrigger value="all" onClick={() => setActiveTab('all')} data-id="element-581">
              Semua
            </TabsTrigger>
            <TabsTrigger value="pending" onClick={() => setActiveTab('pending')} data-id="element-582">
              <Clock className="w-4 h-4 mr-2" data-id="element-583" />
              Menunggu
            </TabsTrigger>
            <TabsTrigger value="approved" onClick={() => setActiveTab('approved')} data-id="element-584">
              <CheckCircle className="w-4 h-4 mr-2" data-id="element-585" />
              Disetujui
            </TabsTrigger>
            <TabsTrigger value="rejected" onClick={() => setActiveTab('rejected')} data-id="element-586">
              <XCircle className="w-4 h-4 mr-2" data-id="element-587" />
              Ditolak
            </TabsTrigger>
          </TabsList>

          <TabsContent value={activeTab} className="mt-6" data-id="element-588">
            <Card data-id="element-589">
              <CardContent className="p-0" data-id="element-590">
                <Table data-id="element-591">
                  <TableHeader data-id="element-592">
                    <TableRow data-id="element-593">
                      <TableHead data-id="element-594">Nama</TableHead>
                      <TableHead data-id="element-595">Email</TableHead>
                      <TableHead data-id="element-596">Tipe</TableHead>
                      <TableHead data-id="element-597">Keanggotaan</TableHead>
                      <TableHead data-id="element-598">Tanggal</TableHead>
                      <TableHead data-id="element-599">Status</TableHead>
                      <TableHead className="text-right" data-id="element-600">Aksi</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody data-id="element-601">
                    {filteredApprovals.map(approval => <TableRow key={approval.id} data-id="element-602">
                        <TableCell data-id="element-603">
                          <p className="font-medium text-neutral-900" data-id="element-604">
                            {approval.name}
                          </p>
                        </TableCell>
                        <TableCell className="text-neutral-600" data-id="element-605">
                          {approval.email}
                        </TableCell>
                        <TableCell data-id="element-606">
                          <Badge variant="default" data-id="element-607">{approval.type}</Badge>
                        </TableCell>
                        <TableCell className="text-neutral-600" data-id="element-608">
                          {approval.membershipType}
                        </TableCell>
                        <TableCell className="text-neutral-600" data-id="element-609">
                          {approval.submittedDate}
                        </TableCell>
                        <TableCell data-id="element-610">
                          <Badge variant={approval.status === 'pending' ? 'warning' : approval.status === 'approved' ? 'success' : 'error'} data-id="element-611">
                            {approval.status === 'pending' ? 'MENUNGGU' : approval.status === 'approved' ? 'DISETUJUI' : 'DITOLAK'}
                          </Badge>
                        </TableCell>
                        <TableCell className="text-right" data-id="element-612">
                          <div className="flex justify-end gap-2" data-id="element-613">
                            <Button size="sm" variant="ghost" onClick={() => navigate(`/admin/approvals/${approval.id}`)} data-id="element-614">
                              <Eye className="w-4 h-4" data-id="element-615" />
                            </Button>
                            {approval.status === 'pending' && <>
                                <Button size="sm" variant="secondary" className="text-error hover:text-error" onClick={() => handleReject(approval.id)} data-id="element-616">
                                  Tolak
                                </Button>
                                <Button size="sm" onClick={() => handleApprove(approval.id)} data-id="element-617">
                                  Setujui
                                </Button>
                              </>}
                          </div>
                        </TableCell>
                      </TableRow>)}
                  </TableBody>
                </Table>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </div>;
}